import axios from 'axios'
import {getCsrfToken, getSessionToken} from '@futures-platform/connectors/session'

const DRUPAL_API_URL = process.env.REACT_APP_DRUPAL_API_URL
const baseUrl = process.env.REACT_APP_VOTING_API_URL
const searchUTL = process.env.REACT_APP_SEARCH_API_URL;

const GET = 'GET'
const POST = 'POST'
const DELETE = 'DELETE'
const PUT = 'PUT'
const PATCH = 'PATCH'

async function httpRequest(method, path, payload = null) {
    return axios({
        method,
        url: `${DRUPAL_API_URL}/v1.0/${path}`,
        headers: {
            'X-CSRF-Token': getCsrfToken(),
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionToken()}`
        },
        withCredentials: true,
        data: payload || null
    }).then(res => res.data)
}

async function httpRequestNew(
  urlParam,
  method,
  path,
  payload = null,
  headers = {},
) {
  return axios({
    method,
    url: `${urlParam}/${path}`,
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getSessionToken()}`,
      ...headers,
    },
    withCredentials: true,
    data: payload || null,
  })
}

async function httpRequestCustom(baseUrl, method, path, payload = null) {
    return axios({
        method,
        url: `${baseUrl}/${path}`,
        headers: {
            'X-CSRF-Token': getCsrfToken(),
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionToken()}`
        },
        withCredentials: true,
        data: payload || null
    })
  }

export async function getMembershipForPublicLink(groupId) {
    // eslint-disable-next-line
    return httpRequest(GET, `membership?filter[gid]=${groupId}&sort=role_weight,email`)
}

export default {
    getMembershipForPublicLink,
}

export const radarAPIs = {
    searchScenarios: async (payload) => {
        return await httpRequestCustom(searchUTL, "POST", `scenario-card`, payload);
      },
    getFlipAxis : async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `meta/rating/${gid}/radar/${radarId}/flipaxis/`)
    },
    getFlipAxisAfterSaved : async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `meta/${gid}/radar/${radarId}/`)
    },
    switchSharedLink: async (radarId, payload) => {
        return await httpRequestCustom(DRUPAL_API_URL, 'PATCH', `v1.0/radars/${radarId}`, payload)
    },
    setExpiredSharedLink: async (radarId, payload) => {
        return await httpRequestCustom(DRUPAL_API_URL, 'PATCH', `v1.0/public-radar-shares?radar_id=${radarId}`, payload)
    },
    //get all radar phenomenon votes
    getVotes: async (gid, radarId, pid) => {
        return await httpRequestCustom(baseUrl, 'GET', `voting/${gid}/radar/${radarId}/phenomenon/${pid}`)
    },
    getAllVotes: async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `voting/${gid}/radar/${radarId}/phenomenon`)
    },
    //get all votes from all phenomenon by radarId
    getAllRatings: async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `rating/${gid}/radar/${radarId}`)
    },
}
export const ratingApi = {
    getFlipAxis : async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `meta/rating/${gid}/radar/${radarId}/flipaxis/`)
    },
    getFlipAxisAfterSaved : async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `meta/rating/${gid}/radar/${radarId}/flipAxisAfterSaved/`)
    },
    changeFlipAxis: async (gid, radarId, payload) => {
        return await httpRequestCustom(baseUrl, 'POST', `meta/rating/${gid}/radar/${radarId}/flipaxis/`, payload)
    },
    changeFlipAxisAfterSaved: async (gid, radarId, payload) => {
        return await httpRequestCustom(baseUrl, 'POST', `meta/rating/${gid}/radar/${radarId}/flipAxisAfterSaved/`, payload)
    },
    //get all radar phenomenon votes
    getVotes: async (gid, radarId, pid) => {
        return await httpRequestCustom(baseUrl, 'GET', `voting/${gid}/radar/${radarId}/phenomenon/${pid}`)
    },
    getAllVotes: async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `voting/${gid}/radar/${radarId}/phenomenon`)
    },
    //get all votes from all phenomenon by radarId
    getAllRatings: async (gid, radarId) => {
        return await httpRequestCustom(baseUrl, 'GET', `rating/${gid}/radar/${radarId}`)
    },
}

// url: `${DRUPAL_API_URL}/v1.0/${path}`,
export const fetcher = {
  getInfoContent: async (id) => {
    try {
      return await httpRequestNew(
        `${DRUPAL_API_URL}`,
        'GET',
        `v1.0/global-settings?id=${id}`,
      )
    } catch (error) {
      console.error('Error getting info content:', error)
      throw error
    }
  }
  
}